<template>
  <div class="content-container">
    <a-form-model
      ref="searchForm"
      class="search-form"
      layout="horizontal"
      :model="searchForm"
      :label-col="{span:5}"
      :wrapper-col="{span:16}"
    >
      <a-row>
        <a-col :span="8">
          <a-form-model-item
            has-feedback
            :label="$t('form.common.field.materialName.label')"
          >
            <a-input
              v-model="searchForm.name"
              :placeholder="$t('form.common.field.materialName.placeholder')"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item
            has-feedback
            :label="$t('form.common.field.status.label')"
          >
            <a-select
              mode="multiple"
              :placeholder="$t('form.common.field.status.placeholder')"
              v-model="searchForm.status"
              :allowClear="true"
            >
              <a-select-option value="0">{{$t('enum.materialAuditStatus.0')}}</a-select-option>
              <a-select-option value="1">{{$t('enum.materialAuditStatus.1')}}</a-select-option>
              <a-select-option value="2">{{$t('enum.materialAuditStatus.2')}}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item>
            <a-button type="primary" html-type="submit" @click="search">{{$t(`actionTitles.submit`)}}</a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="handleReset">{{$t(`actionTitles.clear`)}}</a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <div class="table-wrapper">
      <!-- <div class="opration-wrapper">
        <a-dropdown placement="bottomLeft">
          <a-menu slot="overlay" @click="handleChangeOperate" style="width: 120px">
            <a-menu-item key="offlineDownload">{{$t('message.offlineDownload')}}</a-menu-item>
            <a-menu-item key="delete">{{$t('message.delete')}}</a-menu-item>
            <a-menu-item key="moveTo">{{$t('message.moveTo')}}</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">
            {{$t('message.moreOperate')}}
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div> -->

      <!-- <clear-selected
        alert-type="info"
        :show="selectedRowKeys.length>0"
        :selectedCount="selectedRowKeys.length"
        @clear="onClearSelected"
      /> -->

      <a-table
        :data-source="data"
        :loading="loading"
        :pagination="pagination"
        rowKey="id"
        @change="handleTableChange"
      >
        <a-table-column key="name" :title="$t('table.common.thead.name')" data-index="name">
          <template slot-scope="text, record">
            <div class="work-detail-layout">
              <div class="work-detail-img">
                <img :src="record.url" alt style="width: 40px; height: 40px" v-if="record.type===1" />
                <a-icon
                  type="audio"
                  theme="filled"
                  style="color:#1790ff;font-size: 40px"
                  v-else-if="record.type===2"
                />
                <a-icon
                  type="video-camera"
                  theme="filled"
                  style="color:#1790ff;font-size: 40px"
                  v-else-if="record.type===3"
                />
                  <img :src="record.cover" alt style="width: 40px; height: 40px" v-if="record.type===4" />
              </div>
              <div class="work-name-block">
                <template>
                  <span class="work-name-style">{{record.name}}</span>
                  <!-- <span class="work-name-remark" v-if="record.desc">{{record.desc}}</span> -->
                </template>
              </div>
            </div>
          </template>
        </a-table-column>
        <a-table-column
          key="user_name"
          :title="$t('table.materialAudit.thead.authorAlias')"
          data-index="user_name"
          align="center"
        />
        <a-table-column
          key="filesize"
          :title="$t('table.materialAudit.thead.fileSize')"
          data-index="filesize"
          :sorter="true"
          align="center"
        >
          <template slot-scope="text, record">
            <span>{{record.filesize+'KB'}}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="status"
          :title="$t('table.common.thead.status')"
          data-index="status"
          :filters="filters"
          align="center"
        >
          <template slot-scope="text, record">
            <span :class="[record.status===2? 'status-refuse':'status-default',record.status===1? 'status-pass':'']">
              {{$t(`enum.materialAuditStatus.${record.status}`)}}
            </span>
          </template>
        </a-table-column>
        <a-table-column
          key="create_time"
          :title="$t('table.materialAudit.thead.submissionTime')"
          data-index="create_time"
          :sorter="true"
          align="center"
        />
        <a-table-column key="operate" :title="$t('table.common.thead.operate')" align="center">
          <template slot-scope="text, record">
            <span>
              <a @click.stop="audit(record)">{{$t('actionTitles.audit')}}</a>
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>

    <a-modal
      :title="$t('actionTitles.audit')"
      :visible="isShowAuditrModel"
      @cancel="hideAuditrModel"
      keyboard
      :footer="null"
    >
      <div style="margin-bottom: 20px;text-align:center">
        <img :src="auditItem.url" alt v-if="auditItem.type===1" style="width:auto;max-width:100%;display:inline-block" />
        <audio
          :src="auditItem.url"
          controls="controls"
          v-else-if="auditItem.type===2"
          style="width:100%;margin-bottom:24px"
        >{{$t('message.audioFaileMessage')}}</audio>
        <video
          :src="auditItem.url"
          controls="controls"
          v-else-if="auditItem.type===3 || auditItem.type===4"
          height="100%"
          width="100%"
        >{{$t('message.vedioFaileMessage')}}</video>
      </div>
      <a-form-model
        ref="auditForm"
        :model="auditForm"
        :rules="rules"
        :label-col="{span:5}"
        :wrapper-col="{span:15}"
        v-if="isShowRefuseInput"
        style="margin-top:10px"
      >
        <a-form-model-item ref="reason" :label="$t('form.common.field.refuse.label')" prop="reason">
          <a-textarea
            v-model="auditForm.reason"
            :placeholder="$t('form.common.field.refuse.placeholder')"
            allow-clear
            :autoSize="true"
            @blur="() => {$refs.reason.onFieldBlur();}"
          />
          <!-- <a-input
            v-model="auditForm.reason"
            :placeholder="$t('form.common.field.refuse.placeholder')"
            @blur="
          () => {
            $refs.reason.onFieldBlur();
          }
        "
          /> -->
        </a-form-model-item>
      </a-form-model>
      <footer class="ant-modal-footer">
        <div>
          <button type="button" class="ant-btn" @click="refuse(auditItem.id)">
            <span>{{$t('actionTitles.refuse')}}</span>
          </button>
          <button type="button" class="ant-btn ant-btn-primary" @click="approved(auditItem.id)">
            <span>{{$t('actionTitles.approved')}}</span>
          </button>
        </div>
      </footer>
    </a-modal>
  </div>
</template>


<script>
import ClearSelected from "../../components/ClearSelected";
import { auditMaterialList, auditMaterial } from "@/api/material";

export default {
  data() {
    return {
      searchForm: {
        status:[]
      },
      expand: false,
      form: this.$form.createForm(this, { name: "advanced_search" }),
      data: [],
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
      filters: [
        {
          text: this.$t("enum.materialAuditStatus.0"),
          value: "0",
        },
        {
          text: this.$t("enum.materialAuditStatus.1"),
          value: "1",
        },
        {
          text: this.$t("enum.materialAuditStatus.2"),
          value: "2",
        },
      ],
      isShowAuditrModel: false,
      auditItem: {},
      auditForm: {
        reason: "",
        id: "",
        status: null,
      },
      rules: {
        reason: [
          {
            required: true,
            message: this.$i18n.t("form.common").field.refuse.message,
            trigger: "blur",
          },
        ],
      },
      isShowRefuseInput: false,
    };
  },
  components: { ClearSelected },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      let searchParam = {...this.searchForm,...{
          current_page: this.pagination.current,
          per_page: this.pagination.pageSize,
        }}
      auditMaterialList(searchParam)
        .then((res) => {
          if (res.code === 1) {
            this.loading = false;
            this.data = res.data.data;
            this.pagination.total = res.data.total;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleReset() {
      this.searchForm = {status:[]}
       this.pagination.current=1;
      this.loadData()
    },
    toggle() {
      this.expand = !this.expand;
    },
    handleTableChange(pagination, filters, sorter) {
       this.pagination = pagination;
      if (Object.keys(filters).length > 0) {
        this.searchForm.status = filters.status;
      }
      if (Object.keys(sorter).length > 0) {
        let field = sorter.field;
        let orderStr = sorter.order == "ascend" ? "asc" : "desc";

        let order = {};
        order[field] = orderStr;
        this.searchForm.order = order;
      }
      this.loadData();
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    audit(record) {
      this.isShowAuditrModel = true;
      this.auditItem = record;
    },
    hideAuditrModel() {
      this.isShowAuditrModel = false;
      this.isShowRefuseInput = false;
      this.auditItem = {};
    },
    // handleChangeOperate(e) {
    //   if (!this.selectedRowKeys.length) {
    //     this.$message.warning(this.$t("message.selectHint"), 2);
    //   } else {
    //     if (e.key === "delete") {
    //         let sourse = this.selectedRows.map((v) => {
    //           return {
    //             id: v.id,
    //             type: typeof v.dir_id === "number" ? "pano" : "dir",
    //           };
    //         });
    //         this.delWorks(sourse);
    //     } else if (e.key === "offlineDownload") {
    //         this.selectedRows.map((v) => {
    //           if (typeof v.dir_id === "number") {
    //             downloadFile([v.location]);
    //           }
    //         });
    //     } else if (e.key === "moveTo") {
    //         this.treeVisible = true;
    //     }
    //   }
    // },
    handleAudit(option) {
      auditMaterial(option)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success(this.$t("message.saveSuccess"), 2, () => {});
              this.isShowAuditrModel = false;
              if(this.isShowRefuseInput){
                  this.isShowRefuseInput = false;
                  this.$refs.auditForm.resetFields();
              }
              this.loadData();
          }
        })
        .catch((err) => {});
      this.isShowAuditrModel = false;
    },
    approved(id) {
      this.handleAudit({id,status:1});
    },
    refuse(id) {
      if (!this.isShowRefuseInput) {
        this.isShowRefuseInput = true;
        return;
      } else if (!this.auditForm.reason) {
        this.$message.warning(this.$t("form.common.field.refuse.message"), 2);
        return;
      }
      this.auditForm = { ...this.auditForm, id, status: 2 };
      this.handleAudit(this.auditForm);
    },
    search(){
      this.reset();
      this.loadData();
    },
    reset(){
      this.pagination.current=1;
    }
  },
};
</script>
<style lang="less" scoped>
</style>
